import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCountriesOptions } from "../../../../redux/Actions/countryAction";
import { getPickupAddressesOption } from "../../../../redux/Actions/pickupAddressAction";
import { CheckBoxInput } from "../../../common/Buttons";
import TableColumnAO from "./TableColumnAO";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { setParcelTerminalsOptions } from "../../../../redux/Actions/options_action";
import { imumDisableChannelPriceScopeParams } from "../../../../redux/Actions/imum_action";
import CreatePOAssignSupplyModal from "../Modals/CreatePOAssignSupplyModal";
import AssignSupplyDateModal from "../Modals/AssignSupplyDateModal";
import { QueryClient, QueryClientProvider } from "react-query";
import {
  setGlobalModal,
  getOrdersShipmentsOver80Kg,
} from "../../../../redux/Actions/orderAction";

export const queryProductsClient = new QueryClient();

const { confirm } = Modal;

export default function OrderTable({
  layoutOfTableIncl,
  orders,
  selected_orders_full,
  handleCheck,
  onEdit,
  orders_checked,
  handleSelected,
  updateSerialNumber,
  order_row_type,
  changeTableType,
  reload_for_bulk_shipments,
  supp_date,
  totals,
  pickedSupplierId,
  showAlerts,
}) {
  const dispatch = useDispatch();
  const bulk_shipments = useSelector((state) => state.orders.bulk_shipments);
  const globalModal = useSelector((state) => state.orders.globalModal);
  const permissions = useSelector(
    (state) => state.auth.user.user_role?.permissions || {}
  );
  const canCreatePo = !!permissions.also_income_module_create_po;
  const { parcel_terminals } = useSelector((state) => state.options);
  const ordersParams = useSelector(
    (state) => state.orders.settings.params_filter
  );

  const [additionalOptions, setAdditionalOptions] = useState({
    countries: [],
    pickup_addresses: [],
  });

  const checked_all_orders = useMemo(
    () => orders.every((order) => orders_checked.includes(order.id)),
    [orders.length, orders_checked.length]
  );

  useEffect(() => {
    if (order_row_type == "Extra services") {
      if (additionalOptions.countries.length > 0) return;
      dispatch(setParcelTerminalsOptions());
      Promise.all([getCountriesOptions(), getPickupAddressesOption()]).then(
        (res) => {
          setAdditionalOptions({
            countries: res[0].data,
            pickup_addresses: res[1].data.data.map((address) => ({
              value: address.id,
              label: `${address.code} - ${address.address},  ${address.city}`,
            })),
          });
        }
      );
    }
  }, [order_row_type]);

  const selectedRowsSet = useMemo(
    () => new Set(globalModal?.numbersArray || []),
    [globalModal?.numbersArray]
  );

  // Use cross-page selected orders as modal input source.
  const filteredOrders = (selected_orders_full || []).filter((order) =>
    order.order_rows?.some((row) => selectedRowsSet.has(row.id))
  );

  const hasSupplyings = filteredOrders?.some((order) =>
    order.order_rows?.some((row) => row.supplyings?.length > 0)
  );

  useEffect(() => {
    if (globalModal.modalName === "CreatePOAssignSupplyModal" && canCreatePo) {
      if (hasSupplyings) {
        confirm({
          title: "Are you sure?",
          icon: <ExclamationCircleOutlined className="text-primary" />,
          content:
            "There is already a supplying for this order. Do you want to create a new PO and assign supply?",
          onOk: () => {
            console.log("OK");
          },
          onCancel() {
            dispatch(setGlobalModal(false, null, null));
          },
        });
      }
    }
  }, [globalModal, canCreatePo]);

  useEffect(() => {
    dispatch(getOrdersShipmentsOver80Kg());
  }, [dispatch]);

  return (
    <>
      <table id="orders" className="table table-sm table-hover mt-3">
        <thead>
          <tr className="text-muted">
            <th className="text-black">
              <div className="d-flex">
                <CheckBoxInput
                  checked={checked_all_orders}
                  onChange={() => {
                    return handleCheck("remove", {
                      order_ids: orders
                        .filter(
                          (d) =>
                            orders_checked.includes(d.id) == checked_all_orders
                        )
                        .map((d) => d.id),
                    });
                  }}
                />
              </div>
            </th>
            {layoutOfTableIncl("Eksp") && <th className="text-black">Exp.</th>}
            <th className="text-black">Store</th>
            {layoutOfTableIncl("Užsakymo data") && (
              <th className="text-black">Order date</th>
            )}
            {layoutOfTableIncl("Order numeris") && (
              <th className="text-black">Order no.</th>
            )}
            {layoutOfTableIncl("Klientas") && (
              <th className="text-black">Client</th>
            )}
            {layoutOfTableIncl("Mokėtojas") && (
              <th className="text-black">Payers</th>
            )}
            {layoutOfTableIncl("Gabenimo adresas") && (
              <th className="text-black">Shipping address</th>
            )}
            {layoutOfTableIncl("Prekes") && (
              <th className="text-black">
                <div>Goods</div>
                {!!changeTableType && (
                  <div className="d-flex align-items-center">
                    <div className="text-xs mr-1">Select for</div>
                    {["Supply", "Extra services"].map((type) => (
                      <React.Fragment key={type}>
                        <div
                          className={"text-xs cursor-pointer"}
                          style={
                            order_row_type !== type
                              ? { color: "#9C9C9C" }
                              : {
                                color: "#03B0F7",
                                textDecoration: "underline",
                              }
                          }
                          onClick={() => {
                            changeTableType(type);
                          }}
                        >
                          {type}
                        </div>
                        {type == "Supply" && (
                          <div
                            className="mx-1"
                            style={{
                              width: 2,
                              backgroundColor: "#EDEDED",
                              height: 20,
                            }}
                          ></div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </th>
            )}
            {layoutOfTableIncl("Likučiai") && (
              <th className="text-black">Residues</th>
            )}
            <th></th>
            {layoutOfTableIncl("Mokėjimo būdas") && (
              <th className="text-black">Method of payment</th>
            )}
            {layoutOfTableIncl("Pristatymas") && (
              <th className="text-black">Delivery</th>
            )}
            {layoutOfTableIncl("Statusas") && (
              <th className="text-black">Status</th>
            )}
            {layoutOfTableIncl("KA komentarai") && (
              <th className="text-black">KA comments</th>
            )}
            {layoutOfTableIncl("Vadyba") && (
              <th className="text-black">Manager comments</th>
            )}
            {layoutOfTableIncl("Logistika") && (
              <th className="text-black">Logistic comments</th>
            )}
            {layoutOfTableIncl("Suma") && <th className="text-black">Sum</th>}
            <th className="text-black"></th>
          </tr>
        </thead>
        <tbody>
          {orders.map((item, index) => {
            return (
              <TableColumnAO
                key={item.id}
                index={index}
                id={item.id}
                item={item}
                onEdit={onEdit}
                //

                handleCheck={handleCheck}
                handleSelected={handleSelected}
                //
                checkBoxIncludes={layoutOfTableIncl}
                updateSerialNumber={updateSerialNumber}
                order_row_type={order_row_type}
                bulk_shipments={bulk_shipments[item.id] || []}
                additionalOptions={{
                  ...additionalOptions,
                  parcels: parcel_terminals,
                }}
                reload_for_bulk_shipments={reload_for_bulk_shipments}
                supp_date={supp_date}
                disabled={!changeTableType}
                pickedSupplierId={pickedSupplierId}
                showAlerts={showAlerts}
              />
            );
          })}
        </tbody>
      </table>
      {canCreatePo &&
        globalModal.modalName === "CreatePOAssignSupplyModal" &&
        globalModal.isOpen && (
          <QueryClientProvider client={queryProductsClient}>
            <CreatePOAssignSupplyModal orders={filteredOrders} />
          </QueryClientProvider>
        )}
      {globalModal.modalName === "AssignSupplyDateModal" &&
        globalModal.isOpen && (
          <QueryClientProvider client={queryProductsClient}>
            <AssignSupplyDateModal orders={filteredOrders} />
          </QueryClientProvider>
        )}
    </>
  );
}
